import { useState } from 'react'
import Dialog from '@mui/material/Dialog'

import { Icon } from '../../../../../../components/UI'
import SelectCurrency from '../../../../../../components/Shared/SelectCurrency'

import { myWalletCurrencies } from '../../../../../../constants'

const JobPostActivation = ({ jobPost, onClose, onSuccess }) => {
  const [currency, setCurrency] = useState(myWalletCurrencies[0].value)

  const notEnoughMoney = false

  const handleClose = () => {
    onClose()

    setCurrency(myWalletCurrencies[0].value)
  }

  const handleTopUp = () => {
    handleClose()
  }

  // TODO
  const handleActivate = () => {
    handleClose()

    setTimeout(() => {
      onSuccess({
        title: 'Your Job Post is Now Live!',
        description: 'Congratulations! Your new post has been successfully activated.',
      })
    }, 300)
  }

  return (
    <Dialog
      open={!!jobPost}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex items-center justify-end">
          <button onClick={handleClose}>
            <Icon name="close" color="#FF9053" className="w-[24px] h-[24px]" />
          </button>
        </div>

        <h2 className="text-xl font-bold text-primary-100 text-center">Job Post Activation</h2>

        <h3 className="text-primary-100 text-base font-medium text-center mt-[8px]">
          You will have to pay € 1.99 for creating your Job on the posts page.
        </h3>

        <SelectCurrency value={currency} onChange={setCurrency} className="mt-[16px]" />

        <h4 className="text-primary-100 text-sm leading-[20px] font-medium mt-[16px] text-center">
          Select your desired currency to see the available balance.
        </h4>

        <div className="p-[20px] w-full bg-white rounded-[10px] border-[#FFE4D4] border-[1px] mt-[16px] flex flex-col items-start gap-y-[16px]">
          <div className="w-full flex items-center justify-between">
            <span className="text-sm font-medium text-primary-100">Your balance:</span>

            <span className="text-sm font-bold text-primary-100">0.000055 BTC (€ 43.48)</span>
          </div>

          <div className="w-full flex items-center justify-between">
            <span className="text-sm font-medium text-primary-100">Promote price:</span>

            <span className="text-sm font-bold text-primary-100">0,00046 BTC (€ 9.99)</span>
          </div>
        </div>

        {notEnoughMoney ? (
          <>
            <p className="mt-[24px] text-sm font-medium text-primary-100 text-center" role="alert">
              You don’t have enough credits to pay for the job post activation. Please top up to
              continue.
            </p>

            <button
              className="mt-[24px] h-[44px] w-full rounded-[8px] bg-primary-button hover:bg-primary-button-hover shadow-button flex items-center justify-center text-lg font-semibold text-white transition-colors duration-200 ease"
              onClick={handleTopUp}
            >
              Top Up
            </button>
          </>
        ) : (
          <>
            <button
              className="mt-[24px] h-[44px] w-full rounded-[8px] bg-primary-button hover:bg-primary-button-hover shadow-button flex items-center justify-center text-lg font-semibold text-white transition-colors duration-200 ease"
              onClick={handleActivate}
            >
              Confirm Job Post Activation
            </button>
          </>
        )}
      </div>
    </Dialog>
  )
}

export default JobPostActivation
